// data
const links = [
    {
        text: "Company History",
        url: "/company-history",
    },
    {
        text: "Brand Portfolio",
        url: "/brands",
    },
    {
        text: "Design & Merchandising",
        url: "/design-merchandising",
    },
    {
        text: "Production & Sourcing",
        url: "/production-sourcing",
    },
    {
        text: "Employment",
        url: "/employment",
    },
    {
        text: "Contact",
        url: "/contact",
    },
]

export default links
